export default "__VITE_ASSET__CWHXtPru__"